import { render, staticRenderFns } from "./businessusers.vue?vue&type=template&id=51537265"
import script from "./businessusers.vue?vue&type=script&lang=js"
export * from "./businessusers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports